<!--
* 组件名 : 视频播放页
* 开发者 : JY
*
* 参数:
*   vid             { String } -  视频ID
*   desc             { String } -  视频简介
*   poster          { String } -  视频缩略图
*   title           { String } -  视频标题
*
* 事件: 
*   openVideoPlayer [] - 打开视频播放器
* 
* 
*
-->

<template>
  <div
    class="v-video-card video-card"
    :data-video="vid"
    @click="on_open_player(vid, desc)"
  >
    <div class="card-cover">
      <img :src="poster" :alt="title" />
      <v-btn><v-icon>play_circle_outline</v-icon></v-btn>
    </div>
    <p class="title">{{ title }}</p>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { checkOverflow } from "utils/util";

export default {
  name: "v-video-card",
  props: {
    vid: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      required: "",
    },
    poster: {
      type: String,
      required: "",
    },
    title: {
      type: String,
      required: "",
    },
  },
  methods: {
    //  打开播放器
    on_open_player(vid, desc) {
      this.$videoPlayer({ vid, desc });
    },
  },
};
</script>

<style lang="scss">
.v-video-card {
  margin: 0 16px 42px 16px;
  flex-shrink: 0;

  &.video-card {
    width: 384px;

    .card-cover {
      padding-top: 56.25%;
      background-color: $color-placeholder;

      .v-btn {
        left: 8px;
        bottom: 8px;
        opacity: 0.9;

        i {
          font-size: 26px;
        }
      }
    }

    .title {
      font-size: 18px;
      line-height: 1.45;
      margin-top: 12px;
    }
  }
}
</style>
